import React, { useState } from "react";
import { useSelector } from "react-redux";
import ExpressCheckoutModal from "../../../ui/organisms/ExpressCheckoutModal/index";
import Or from "./Or";

const ExpressCheckout = ({ subscriptionNum, displayButtonOnly }) => {
  const [buttonType, setButtonType] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [paymentRequest, setPaymentRequest] = useState(null);
  const presenter = useSelector((state) => state.company.presenter);
  const isUS = presenter.data_country === "US";

  React.useEffect(() => {
    document
      .getElementById("express-container")
      ?.classList.add("elementToFadeIn");
    setTimeout(() => {
      document
        .getElementById("express-container")
        ?.classList.remove("elementToFadeIn");
    }, 600);
  }, [displayButtonOnly]);

  return (
    <div id="express-container">
      <ExpressCheckoutModal
        shouldDisplay={showModal}
        setShowModal={setShowModal}
        subscriptionNum={subscriptionNum}
        setButtonType={setButtonType}
        buttonType={buttonType}
        paymentRequest={paymentRequest}
        setPaymentRequest={setPaymentRequest}
        displayButtonOnly={displayButtonOnly}
      />
      {!!paymentRequest && !displayButtonOnly ? (
        <div className="express-col">
          <div className="checkout-head">Express Checkout</div>
          <div className="express-checkout-container">
            <div>
              <div
                onClick={() => {
                  setShowModal(true);
                }}
                className={
                  buttonType === "GOOGLE_PAY"
                    ? "dummy-express-button google-pay-button"
                    : buttonType === "APPLE_PAY"
                      ? "dummy-express-button apple-pay-button"
                      : buttonType === "LINK"
                        ? "dummy-express-button link-pay-button"
                        : "dummy-express-button express-pay-button"
                }
              >
                {buttonType === "LINK" ? (
                  <>
                    <span>Pay with</span>
                    <span className="link-name"></span>
                    <span className="link-logo"></span>
                  </>
                ) : buttonType !== "GOOGLE_PAY" &&
                  buttonType !== "APPLE_PAY" ? (
                  <span>Express Checkout</span>
                ) : null}
              </div>
            </div>
          </div>
          <Or />
        </div>
      ) : null}
    </div>
  );
};

export default ExpressCheckout;
